/* import __COLOCATED_TEMPLATE__ from './first-last-name-row.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();